import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import { getBase64, } from '../../../helpers';
import request from 'superagent';
import config from '../../../config';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';

class AddHotel extends React.Component {
    state = {
        hotel: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { hotels = [], hotelsActions, params } = this.props, { id } = params;
        if (id) {
            if (hotels && hotels.length && _.find(hotels, a => a.IdHotel === id)) {
                this.setState({ hotel: _.find(hotels, a => a.IdHotel === id) })
            } else {
                this.setState({ microTransac: true }, () => { hotelsActions && hotelsActions.fetch(id); });
            }
        } else {
            this.setState({ hotel: {} });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { hotel } = nextProps;
        this.setState({ hotel, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => { this.props.router.push('/admin'); });
    }
    handleAvatar = e => {
        const { hotel } = this.state;
        getBase64(e.target.files[0]).then(data => {
            hotel.HotelLogo = data;
            this.setState({ hotel });
        });
    }
    save = () => {
        const { hotel } = this.state, { hotelsActions } = this.props;
        hotel.HotelName = this.txtName.value;
        hotel.HotelDescription = this.txtDescription.value;
        hotel.HotelAddress = this.txtAddres.value;        
        hotel.HotelLink = this.txtUrl.value;        

        this.setState({ microTransac: true }, () => {
            request[hotel.IdHotel ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/hotels${hotel.IdHotel ? `/${hotel.IdHotel}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(hotel)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        hotelsActions.fetch();
                        this.props.router.push('/admin/hotels');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { hotel } = this.state, { hotelsActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/hotels/${hotel.IdHotel}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        hotelsActions.fetch();
                        this.props.router.push('/admin/hotels');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    render() {
        const { hotel = {}, microTransac } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/hotels" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">HOTELS | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={8} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {hotel &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4 bg-black">
                                    <label htmlFor="name" className="white">Hotel Name</label>
                                    <input className="" type="text" required ref={(i) => this.txtName = i} defaultValue={hotel.HotelName} />
                                    <label htmlFor="name" className="white">Description</label>
                                    <input className="" type="text" required ref={(i) => this.txtDescription = i} defaultValue={hotel.HotelDescription} />
                                    <label htmlFor="name" className="white">Address</label>
                                    <input className="" type="text" required ref={(i) => this.txtAddres = i} defaultValue={hotel.HotelAddress} />
                                    <label htmlFor="name" className="white">Link / Url</label>
                                    <input className="" type="text" required ref={(i) => this.txtUrl = i} defaultValue={hotel.Url || hotel.HotelLink} />
                                    
                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="fi" onChange={this.handleAvatar} className="hide" ref={i => this.avatarFU = i} />
                                        <label htmlFor="fi" className="d-flex flex-column justify-content-center h-100">
                                            {!hotel.HotelLogo && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {hotel.HotelLogo && <img alt="" style={{ height: 100 }} src={hotel.HotelLogo} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center white">{hotel.HotelLogo ? 'Change' : 'Add'}{' '}Logo</span>
                                        </label>
                                    </div>
                                    <div className="d-flex flex-row">
                                        {hotel.IdHotel && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/hotels" className="align-self-center btn-link text-center ml-auto margin-right white">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-black text-center">SAVE</button>
                                    </div>
                                    {hotel.IdHotel && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddHotel;



// WEBPACK FOOTER //
// ./src/components/private/hotels/add.js